import { NavLink, useLocation } from 'react-router-dom';
import { NAV_SECTIONS, findActiveNav } from './navConfig';
import { canSeeNavItem } from './navPerms';

// Horizontal subheading selector: renders the subheadings (items) of the
// category that owns the current route as underline tabs at the top of the
// content area. Hidden when the route isn't in the nav, or when the active
// category has a single item (a one-tab bar is just noise). Everything is
// derived from the URL — no selected-category state to keep in sync.
export function SectionTabs(): JSX.Element | null {
  const { pathname } = useLocation();

  const visibleSections = NAV_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter(canSeeNavItem),
  })).filter((section) => section.items.length > 0);

  const active = findActiveNav(pathname, visibleSections);
  if (!active || active.section.items.length <= 1) return null;

  return (
    <nav className="sub-tabs" aria-label={`${active.section.label} sections`}>
      {active.section.items.map((item) => {
        const isActive = item.to === active.item.to;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/app'}
            className={`sub-tab ${isActive ? 'active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
          >
            {item.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
